/// <reference types="@angular/localize" />

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app.config';
import { AppComponent } from './root/app.component';

// Register French locale
registerLocaleData(localeFr);

// prettier-ignore
(async () => { // NOSONAR: Top-level await not supported by build target
  try {
    await bootstrapApplication(AppComponent, {
      ...appConfig,
      providers: [provideZoneChangeDetection(), ...appConfig.providers],
    });
  } catch (err) {
    console.error(err);
  }
})();
